<template>
    <form @submit.prevent="submit">
        <modal>
            <modal-header>
                <translate>Anfrage ablehnen</translate>
            </modal-header>
            <modal-content>
                <form-select id="reject_reason" :label="this.$gettext('Grund für Ablehnung')" :error="form.errors.reject_reason" v-model="form.reject_reason"
                             :options="rejectReasons"/>
                <form-text id="reject_comment" :label="this.$gettext('Ihr Kommentar')" :error="form.errors.reject_comment" v-model="form.reject_comment" />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="error" :disabled="form.processing" :class="{'btn--processing': form.processing}"><translate>Anfrage ablehnen</translate></form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormText from '@partfactory/Shared/Form/FormText';

export default {
    name: 'ComponentReject',
    components: {FormText, FormSelect, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        bidRoundMember: Object
    },
    emit: ['closeDialog'],
    data() {
        const form = useForm({
            reject_reason: null,
            reject_comment: null,
        });

        // todo: config
        const rejectReasons = [
            {value: 'Keine Kapazitäten frei', text: this.$gettext('Keine Kapazitäten frei')},
            {value: 'Können wir nicht produzieren', text: this.$gettext('Können wir nicht produzieren')},
        ];

        return {form, rejectReasons};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('quote.reject', {'bidRoundMember': this.bidRoundMember.id}), {
                    onSuccess: () => this.$emit('closeDialog')
                });
        }
    }
};
</script>
